<mat-card *ngIf="pbo && pos" [ngClass]="changed ? 'order-changed' : ''">
  <mat-card-content>
    <div class="ps-grid-3-col">
      <div>
        <h2 class="mat-h2">
          <img class="mat-icon" src="{{ pos.ICON_URL }}" />
          {{ pos.NAME }}
        </h2>
        <div>{{ pos.SNR }}</div>
        <div>{{ pos.PROJEKT_NAME }} {{ pos.PROJEKT_DESCRIPTION }}</div>
        <div *ngIf="isInternal()">
          {{ 'orders.positions.bm.delivered' | translate }}
          <mat-checkbox
            disabled
            [checked]="pos.DWS_ISTGELIEFERT"></mat-checkbox>
        </div>
        <div *ngIf="isInternal()">
          {{ 'orders.positions.bm.toolType' | translate }}:
          {{ pos.WERKZEUGART }}
        </div>
        <div *ngIf="isInternal()">
          {{ 'orders.positions.bm.toolModel' | translate }}:
          {{ pos.AUSFUEHRUNG }}
        </div>
      </div>
      <div>
        <mat-icon>schedule</mat-icon>
        {{ pos.TERMINA | date }}
      </div>
      <div class="booking-tag" *ngIf="pos.IS_OMITTED; else notOmitted">
        {{ 'orders.positions.omitted' | translate }}
      </div>
      <ng-template #notOmitted>
        <div>
          <span>{{ 'orders.positions.bm.blanks' | translate }}</span>
          <div>
            <mat-icon>functions</mat-icon>
            <span
              >{{ pos.POS_BLANKS_DELIVERED }} / {{ pos.POS_BLANKS_TOTAL }}</span
            >
          </div>
        </div>
      </ng-template>
    </div>
    <div class="ps-flex-container-col">
      <div style="justify-self: end; align-self: end">
        <div *ngIf="pos.POS_HAS_WAP" style="color: #2e7d32">
          <mat-icon>check_circle</mat-icon>
          ABNAHMEPROTOKOLL
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <ng-container *ngIf="isInternal(); else external">
      <button
        *ngIf="
          pos.PBO_DELIVERY_DOC_ID === 0 &&
          !pos.DWS_ISTGELIEFERT &&
          !pos.IS_OMITTED
        "
        mat-button
        color="primary"
        (click)="createBmDelivery()"
        matTooltip="{{
          'orders.positions.bm.shipWithDeliveryNote' | translate
        }}">
        <mat-icon matBadge="+" matBadgeColor="accent">local_shipping</mat-icon>
      </button>
      <button
        *ngIf="pos.PBO_DELIVERY_DOC_ID > 0 && !pos.IS_OMITTED"
        mat-button
        color="primary"
        (click)="downloadDeliveryNote(pos)"
        matTooltip="{{
          'orders.positions.bm.downloadDeliveryNote' | translate
        }}">
        <mat-icon>local_shipping</mat-icon>
      </button>
      <button
        *ngIf="suppliersService.hasPseChangeDocument(pos) && !pos.IS_OMITTED"
        mat-button
        color="primary"
        matTooltip="{{ 'orders.positions.bm.changeRemark' | translate }}"
        (click)="openChangedDialog()">
        <mat-icon>task_alt</mat-icon>
      </button>
    </ng-container>
    <ng-template #external>
      <button
        mat-button
        color="primary"
        routerLink="/orders/{{ pbo.OBJECT_ID }}/{{ pos.OBJECT_ID }}/blanks"
        matTooltip="{{ 'orders.positions.bm.blanks' | translate }}">
        <mat-icon>list_alt</mat-icon>
      </button>
      <span *ngIf="!pos.IS_OMITTED">|</span>
      <button
        *ngIf="!pos.IS_OMITTED"
        mat-button
        color="primary"
        routerLink="/orders/{{ pbo.OBJECT_ID }}/{{
          pos.OBJECT_ID
        }}/projectstatus"
        matTooltip="Projektstatus">
        <mat-icon>assignment_turned_in</mat-icon>
      </button>
      <button
        *ngIf="!pos.IS_OMITTED"
        mat-button
        color="primary"
        (click)="insertProjectStatus(pos.OBJECT_ID)"
        matTooltip="{{
          'orders.positions.bm.createProjectStatus' | translate
        }}">
        <mat-icon>add</mat-icon>
      </button>
      <span>|</span>
      <button
        *ngIf="!pos.IS_OMITTED"
        mat-button
        color="primary"
        (click)="downloadToolAcceptanceReport()"
        matTooltip="{{ 'orders.positions.bm.wap.download' | translate }}">
        <mat-icon>file_download</mat-icon>
      </button>
      <button
        *ngIf="!pos.IS_OMITTED"
        mat-button
        color="primary"
        (click)="uploadToolAcceptanceReport()"
        matTooltip="{{ 'orders.positions.bm.wap.upload' | translate }}">
        <mat-icon>file_upload</mat-icon>
      </button>
      <span
        *ngIf="suppliersService.hasPseChangeDocument(pos) && !pos.IS_OMITTED"
        >|</span
      >
      <button
        *ngIf="suppliersService.hasPseChangeDocument(pos) && !pos.IS_OMITTED"
        mat-button
        color="primary"
        matTooltip="{{ 'orders.positions.bm.changeRemark' | translate }}"
        (click)="openChangedDialog()">
        <mat-icon>task_alt</mat-icon>
      </button>
    </ng-template>
  </mat-card-actions>
</mat-card>
